import axios from "axios";
import { VirtualTokenActions } from "./virtualTokenAction";
import { showSuccessSnackbar } from "../../snackBar/snackBar.action";

//get all Virtual Token api
export const getAllVirtualTokenAsync = (search, searchText, type) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      let { skip, limit } = getState().virtualTokenManagement;

      dispatch(VirtualTokenActions.getAllVirtualTokenStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/virtualToken/getAllVirtualTokens`,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          search: searchText,
          skip,
          limit,
        },
      });
      if (data.statusCode === 200) {
        return dispatch(VirtualTokenActions.getAllVirtualTokenSuccess(data));
      }
      dispatch(VirtualTokenActions.getAllVirtualTokenError());
    } catch (error) {
      dispatch(VirtualTokenActions.getAllVirtualTokenError());
      dispatch(showSuccessSnackbar("error", "Error while fetching data", 3000));
    }
  };
};

//create Virtual Token api
export const addVirtualTokenAsync = (
  values,
  setSubmitting,
  resetForm,
  redirectBack
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      dispatch(VirtualTokenActions.addVirtualTokenStart());
      const { data } = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/virtualToken/addVirtualToken`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });

      if (data.statusCode === 201) {
        dispatch(VirtualTokenActions.addVirtualTokenSuccess(data.data));
        setSubmitting(false);
        resetForm();
        redirectBack();
        return dispatch(
          showSuccessSnackbar(
            "success",
            "Virtual Token Added Successfully",
            3000
          )
        );
      }
      dispatch(VirtualTokenActions.addVirtualTokenError());
      setSubmitting(false);
      return dispatch(showSuccessSnackbar("error", data.responseMessage, 3000));
    } catch (error) {
      dispatch(VirtualTokenActions.addVirtualTokenError(error));
      setSubmitting(false);
      resetForm();
      dispatch(showSuccessSnackbar("error", error.data.message, 3000));
    }
  };
};
//update Virtual Token api
export const updateVirtualTokenAsync = (
  values,
  setSubmitting = () => {},
  resetForm = () => {},
  redirectBack = () => {}
) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      let { selectedVirtualToken } = getState().virtualTokenManagement;

      let virtualTokenId =
        selectedVirtualToken == null ? values.id : selectedVirtualToken._id;
      // only set for condition no use in data
      delete values.id;
      dispatch(VirtualTokenActions.updateVirtualTokenStart());
      const { data } = await axios({
        method: "PUT",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/virtualToken/editVirtualToken/${virtualTokenId}`,
        headers: {
          "Content-Type": "application/json",
        },
        data: values,
      });
      if (data.statusCode === 200) {
        dispatch(VirtualTokenActions.updateVirtualTokenSuccess(data));
        setSubmitting(false);
        resetForm();
        redirectBack();
        return dispatch(
          showSuccessSnackbar(
            "success",
            "Virtual Token Updated Successfully",
            3000
          )
        );
      }
      dispatch(VirtualTokenActions.updateVirtualTokenError());
      setSubmitting(false);
      return dispatch(showSuccessSnackbar("error", data.responseMessage, 3000));
    } catch (error) {
      setSubmitting(false);
      resetForm();
      dispatch(VirtualTokenActions.updateVirtualTokenError(error));
      dispatch(showSuccessSnackbar("error", error.data.message, 3000));
    }
  };
};
//delete Virtual Token api
export const deleteVirtualTokenAsync = (id) => {
  return async (dispatch, getState) => {
    try {
      const adminBaseURL = process.env.REACT_APP_BASE_URL;

      dispatch(VirtualTokenActions.deleteVirtualTokenStart());
      const { data } = await axios({
        method: "DELETE",
        url: `${process.env.REACT_APP_HOST}${adminBaseURL}/virtualToken/deleteVirtualToken/${id}`,
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (data.statusCode === 200) {
        dispatch(VirtualTokenActions.deleteVirtualTokenSuccess(data));
        return dispatch(
          showSuccessSnackbar(
            "success",
            "Virtual Token Deleted Successfully",
            3000
          )
        );
      }
      dispatch(VirtualTokenActions.deleteVirtualTokenError());

      return dispatch(showSuccessSnackbar("error", data.responseMessage, 3000));
    } catch (error) {
      dispatch(VirtualTokenActions.deleteVirtualTokenError(error));
      dispatch(showSuccessSnackbar("error", error.data.message, 3000));
    }
  };
};
